import React from 'react';
import { FaCalendarAlt, FaVideo, FaUserCheck, FaClock } from 'react-icons/fa';

const formatAuditionDate = (dateStr) => {
  if (!dateStr || dateStr === 'Walk-in') return 'Walk-in / Flexi Schedule';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch (e) {
    return dateStr;
  }
};

const MeetingInfo = ({ selectedApp, expired }) => {
  const mode = String(selectedApp.bookingType || 'FACE_TO_FACE').toUpperCase();
  const formattedSchedule = formatAuditionDate(selectedApp.auditionDateTime || selectedApp.slot_datetime);

  return (
    <div className="card-dark p-3 rounded-3 mb-4" style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
      <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom border-secondary border-opacity-25">
        <div className="fw-bold text-white fs-6 d-flex align-items-center gap-2">
          {mode === 'VIDEO_UPLOAD' ? <FaVideo className="text-danger" /> : <FaUserCheck className="text-success" />}
          Audition Mode & Schedule
        </div>
        <span className="pmp-status-tag pmp-status-active">
          {mode.replace(/_/g, ' ')}
        </span>
      </div>

      <div className="p-3 rounded-3" style={{ background: '#1a1a1a', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
        <div className="d-flex align-items-center gap-2 text-muted mb-2 small">
          <FaUserCheck className="text-info" size={13} />
          <span>Audition Mode:</span>
          <strong className="text-white ms-1">{mode.replace(/_/g, ' ')}</strong>
        </div>

        <div className="d-flex align-items-center gap-2 text-muted small mb-2">
          <FaCalendarAlt className="text-warning" size={13} />
          <span>Scheduled Time:</span>
          <strong className="text-white ms-1">{formattedSchedule}</strong>
        </div>

        {selectedApp.meetingLink && !expired && (
          <div className="mt-3">
            <a 
              href={selectedApp.meetingLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-success btn-sm w-100 fw-bold d-flex align-items-center justify-content-center gap-2 shadow-sm"
              style={{ fontSize: '0.85rem' }}
            >
              <FaVideo size={14} /> Join Live Meeting Room
            </a>
          </div>
        )}

        {selectedApp.meetingLink && expired && (
          <div className="mt-2 text-center">
            <span className="pmp-status-tag pmp-status-expired d-inline-flex align-items-center gap-1">
              <FaClock size={11} /> Meeting Session Expired
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MeetingInfo;